import state from '@/store/modules/common/state';
import actions from '@/store/modules/common/actions';
import mutations from '@/store/modules/common/mutations';
import getters from '@/store/modules/common/getters';

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
